/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0AuthAliveGet$Json } from '../fn/auth/api-v-0-auth-alive-get-json';
import { ApiV0AuthAliveGet$Json$Params } from '../fn/auth/api-v-0-auth-alive-get-json';
import { apiV0AuthAliveGet$Plain } from '../fn/auth/api-v-0-auth-alive-get-plain';
import { ApiV0AuthAliveGet$Plain$Params } from '../fn/auth/api-v-0-auth-alive-get-plain';
import { apiV0AuthAuthenticatePost$Json } from '../fn/auth/api-v-0-auth-authenticate-post-json';
import { ApiV0AuthAuthenticatePost$Json$Params } from '../fn/auth/api-v-0-auth-authenticate-post-json';
import { apiV0AuthAuthenticatePost$Plain } from '../fn/auth/api-v-0-auth-authenticate-post-plain';
import { ApiV0AuthAuthenticatePost$Plain$Params } from '../fn/auth/api-v-0-auth-authenticate-post-plain';
import { apiV0AuthLoginPost$Json } from '../fn/auth/api-v-0-auth-login-post-json';
import { ApiV0AuthLoginPost$Json$Params } from '../fn/auth/api-v-0-auth-login-post-json';
import { apiV0AuthLoginPost$Plain } from '../fn/auth/api-v-0-auth-login-post-plain';
import { ApiV0AuthLoginPost$Plain$Params } from '../fn/auth/api-v-0-auth-login-post-plain';
import { apiV0AuthLogoutPost } from '../fn/auth/api-v-0-auth-logout-post';
import { ApiV0AuthLogoutPost$Params } from '../fn/auth/api-v-0-auth-logout-post';
import { apiV0AuthRefreshPost$Json } from '../fn/auth/api-v-0-auth-refresh-post-json';
import { ApiV0AuthRefreshPost$Json$Params } from '../fn/auth/api-v-0-auth-refresh-post-json';
import { apiV0AuthRefreshPost$Plain } from '../fn/auth/api-v-0-auth-refresh-post-plain';
import { ApiV0AuthRefreshPost$Plain$Params } from '../fn/auth/api-v-0-auth-refresh-post-plain';
import { AuthResult } from '../models/auth-result';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0AuthAuthenticatePost()` */
  static readonly ApiV0AuthAuthenticatePostPath = '/api/v0/auth/authenticate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AuthAuthenticatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthAuthenticatePost$Plain$Response(params?: ApiV0AuthAuthenticatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0AuthAuthenticatePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AuthAuthenticatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthAuthenticatePost$Plain(params?: ApiV0AuthAuthenticatePost$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0AuthAuthenticatePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AuthAuthenticatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthAuthenticatePost$Json$Response(params?: ApiV0AuthAuthenticatePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0AuthAuthenticatePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AuthAuthenticatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthAuthenticatePost$Json(params?: ApiV0AuthAuthenticatePost$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0AuthAuthenticatePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiV0AuthLoginPost()` */
  static readonly ApiV0AuthLoginPostPath = '/api/v0/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AuthLoginPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthLoginPost$Plain$Response(params?: ApiV0AuthLoginPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResult>> {
    const obs = apiV0AuthLoginPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AuthLoginPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthLoginPost$Plain(params?: ApiV0AuthLoginPost$Plain$Params, context?: HttpContext): Observable<AuthResult> {
    const resp = this.apiV0AuthLoginPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResult>): AuthResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AuthLoginPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthLoginPost$Json$Response(params?: ApiV0AuthLoginPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResult>> {
    const obs = apiV0AuthLoginPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AuthLoginPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthLoginPost$Json(params?: ApiV0AuthLoginPost$Json$Params, context?: HttpContext): Observable<AuthResult> {
    const resp = this.apiV0AuthLoginPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResult>): AuthResult => r.body)
    );
  }

  /** Path part for operation `apiV0AuthRefreshPost()` */
  static readonly ApiV0AuthRefreshPostPath = '/api/v0/auth/refresh';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AuthRefreshPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthRefreshPost$Plain$Response(params?: ApiV0AuthRefreshPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResult>> {
    const obs = apiV0AuthRefreshPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AuthRefreshPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthRefreshPost$Plain(params?: ApiV0AuthRefreshPost$Plain$Params, context?: HttpContext): Observable<AuthResult> {
    const resp = this.apiV0AuthRefreshPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResult>): AuthResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AuthRefreshPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthRefreshPost$Json$Response(params?: ApiV0AuthRefreshPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResult>> {
    const obs = apiV0AuthRefreshPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AuthRefreshPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AuthRefreshPost$Json(params?: ApiV0AuthRefreshPost$Json$Params, context?: HttpContext): Observable<AuthResult> {
    const resp = this.apiV0AuthRefreshPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResult>): AuthResult => r.body)
    );
  }

  /** Path part for operation `apiV0AuthLogoutPost()` */
  static readonly ApiV0AuthLogoutPostPath = '/api/v0/auth/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AuthLogoutPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AuthLogoutPost$Response(params?: ApiV0AuthLogoutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0AuthLogoutPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AuthLogoutPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AuthLogoutPost(params?: ApiV0AuthLogoutPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0AuthLogoutPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0AuthAliveGet()` */
  static readonly ApiV0AuthAliveGetPath = '/api/v0/auth/alive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AuthAliveGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AuthAliveGet$Plain$Response(params?: ApiV0AuthAliveGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0AuthAliveGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AuthAliveGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AuthAliveGet$Plain(params?: ApiV0AuthAliveGet$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0AuthAliveGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AuthAliveGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AuthAliveGet$Json$Response(params?: ApiV0AuthAliveGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0AuthAliveGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AuthAliveGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AuthAliveGet$Json(params?: ApiV0AuthAliveGet$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0AuthAliveGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
